"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const Input_1 = require("~/components/UI/Input");
const controls_1 = require("~/components/common/controls");
const isEmail_1 = __importDefault(require("~/utils/isEmail"));
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const assets_1 = require("~/assets");
const react_helmet_async_1 = require("react-helmet-async");
const CustomerInfo_1 = __importDefault(require("../EditCustomerModal/CustomerInfo/CustomerInfo"));
const AddressesController_1 = __importDefault(require("./AddressesController"));
const DiscountsController_1 = __importDefault(require("./DiscountsController"));
const AddCustomerModal_module_scss_1 = __importDefault(require("./AddCustomerModal.module.scss"));
function AddCustomerModal({ cancelHandler, submitHandler, distributorId, }) {
    const { t } = (0, react_i18next_1.useTranslation)(['customer', 'authorization']);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const [email, setEmail] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [firstName, setFirstName] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [lastName, setLastName] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [companyName, setCompanyName] = (0, react_1.useState)('');
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)({ value: '', error: null });
    const phoneInputHandler = (key, value) => {
        setPhoneNumber({ value, error: phoneNumber.error });
    };
    const phoneErrorHandler = (key, value) => {
        setPhoneNumber({ value: phoneNumber.value, error: value === 'none' ? null : value });
    };
    const [shippingAddresses, setShippingAddresses] = (0, react_1.useState)([]);
    const [discounts, setDisacounts] = (0, react_1.useState)([]);
    const [areAllAddressesValid, setAreAllAddressesValid] = (0, react_1.useState)(true);
    const [areAllDiscountsValid, setAreAllDiscountsValid] = (0, react_1.useState)(true);
    const { dispatchSignup, dispatchAddCustomer, dispatchSetCustomerExist, dispatchSetExistingCustomerInfo, dispatchSetCustomerRequestSuccess, } = (0, redux_1.bindActionCreators)({
        dispatchSignup: actions_1.inviteCustomer,
        dispatchAddCustomer: actions_1.addCustomer,
        dispatchSetCustomerExist: actions_1.setCustomerExist,
        dispatchSetExistingCustomerInfo: actions_1.setCustomerData,
        dispatchSetCustomerRequestSuccess: actions_1.setCustomerRequestSuccess,
    }, (0, react_redux_1.useDispatch)());
    const resetState = () => {
        dispatchSetCustomerExist(false);
        dispatchSetExistingCustomerInfo(null);
        dispatchSetCustomerRequestSuccess(false);
    };
    const closeCustomerAdding = () => {
        resetState();
        if (cancelHandler) {
            cancelHandler();
        }
        else {
            navigate(-1);
        }
    };
    const isCustomerExist = (0, react_redux_1.useSelector)(selectors_1.selectIsCustomerExist);
    const customerData = (0, react_redux_1.useSelector)(selectors_1.selectExistingCustomerInfo);
    const isRequestSuccessed = (0, react_redux_1.useSelector)(selectors_1.selectIsCustomerRequestSuccessed);
    const signUpCustomer = (event) => {
        var _a;
        event.preventDefault();
        const currentDistributorId = (_a = distributorId !== null && distributorId !== void 0 ? distributorId : user === null || user === void 0 ? void 0 : user.distributorId) !== null && _a !== void 0 ? _a : undefined;
        const signUpData = {
            email: email.value,
            lastName: lastName.value,
            firstName: firstName.value,
            companyName,
            phoneNumber: phoneNumber.value,
            shippingAddresses,
            discounts,
            distributorId: currentDistributorId,
        };
        if (isCustomerExist) {
            if (!customerData) {
                return;
            }
            dispatchAddCustomer(Object.assign(Object.assign({}, customerData), { discounts, distributorId: currentDistributorId }));
        }
        else {
            dispatchSignup(signUpData);
        }
    };
    (0, react_1.useEffect)(() => {
        if (isRequestSuccessed && !cancelHandler) {
            closeCustomerAdding();
        }
        else if (isRequestSuccessed && submitHandler) {
            submitHandler();
            resetState();
        }
    }, [isRequestSuccessed]);
    return (react_1.default.createElement(UI_1.ContentListModal, { headlineContent: react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.header },
            react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.title }, t('add-customer')),
            react_1.default.createElement(react_helmet_async_1.Helmet, null,
                react_1.default.createElement("title", null, "Add Customer | TBUILD")),
            react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.controls },
                react_1.default.createElement(UI_1.Button, { variant: "default", onClick: closeCustomerAdding }, t('actions.cancel')),
                react_1.default.createElement(UI_1.Button, { variant: "primary", disabled: Boolean(email.error || firstName.error || lastName.error || phoneNumber.error) ||
                        Boolean(!(0, isEmail_1.default)(email.value) || firstName.value.trim() === '' || lastName.value.trim() === '') ||
                        !areAllAddressesValid ||
                        !areAllDiscountsValid, onClick: signUpCustomer }, isCustomerExist ? t('actions.confirm') : t('actions.add')))), mainContent: react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.content },
            isCustomerExist ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.warning },
                    react_1.default.createElement("img", { src: assets_1.svgFlashError, className: AddCustomerModal_module_scss_1.default.img, alt: "error" }),
                    react_1.default.createElement("div", null, t('customer-exists'))),
                react_1.default.createElement(CustomerInfo_1.default, { customer: customerData }))) : (react_1.default.createElement("div", null,
                react_1.default.createElement("form", null,
                    react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.row },
                        react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.element_growing },
                            react_1.default.createElement("label", null, t('information.first-name')),
                            react_1.default.createElement(Input_1.Input, { type: "text", placeholder: t('placeholder.first-name'), value: firstName.value, onChange: (value, error) => setFirstName({ value, error }), onInput: (value, error) => setFirstName({ value, error }), maxLength: 60, required: true, customErrors: { required: t('firstName.error.required', { ns: 'authorization' }) } })),
                        react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.element_growing },
                            react_1.default.createElement("label", null, t('information.last-name')),
                            react_1.default.createElement(Input_1.Input, { type: "text", placeholder: t('placeholder.last-name'), value: lastName.value, onChange: (value, error) => setLastName({ value, error }), onInput: (value, error) => setLastName({ value, error }), maxLength: 60, required: true, customErrors: { required: t('lastName.error.required', { ns: 'authorization' }) } }))),
                    react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.row },
                        react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.element_growing },
                            react_1.default.createElement("label", null, t('information.email')),
                            react_1.default.createElement(Input_1.Input, { type: "email", placeholder: t('placeholder.email'), value: email.value, onChange: (value, error) => setEmail({ value, error }), onInput: (value, error) => setEmail({ value, error }), maxLength: 255, required: true, customErrors: { required: t('email.error.required', { ns: 'authorization' }) } })),
                        react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.element_growing },
                            react_1.default.createElement("label", null, t('information.phone-number')),
                            react_1.default.createElement(controls_1.PhoneNumberInput, { state: phoneNumber, inputKey: "phoneNumber", onInput: phoneInputHandler, onError: phoneErrorHandler }))),
                    react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.row },
                        react_1.default.createElement("div", { className: AddCustomerModal_module_scss_1.default.element_growing },
                            react_1.default.createElement("label", null, t('information.company')),
                            react_1.default.createElement(Input_1.Input, { type: "text", placeholder: t('placeholder.company'), maxLength: 255, value: companyName, onChange: setCompanyName })))))),
            react_1.default.createElement(DiscountsController_1.default, { discountsArr: discounts, onValidStateChange: setAreAllDiscountsValid, onDiscountsChange: setDisacounts }),
            !isCustomerExist ? (react_1.default.createElement(AddressesController_1.default, { addressesArr: shippingAddresses, onValidStateChange: setAreAllAddressesValid, onAddressesChange: setShippingAddresses })) : null) }));
}
AddCustomerModal.defaultProps = {
    cancelHandler: undefined,
    submitHandler: undefined,
    distributorId: undefined,
};
exports.default = AddCustomerModal;
